// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110756/js/" + chunkId + "." + {"44":"a47835d6","225":"dc422910","481":"302ad1b2","486":"715f3307","770":"829c4aba"}[chunkId] + ".0.25682155234581827.chunk.js";
};